import React, {useEffect, useState} from 'react'
import {Button, Col, Form, Input, Row, Spin} from "antd";
import api from "../../api";
import {useParams} from "react-router-dom";
import PlanBox from "../../Components/PlanBox";
import {formatPlanPrice} from "../../helpers";
import {useTranslations} from "../../lang";
import PurchaseDisclosure from "../../Components/PurchaseDisclosure";
import {createFunnelEventId, trackFunnelEvent} from "../../analytics";

// Mapping from Mollie payment method IDs to icon file names
const PAYMENT_METHOD_ICONS = {
    'ideal': 'iDEAL',
    'creditcard': 'Credit card',
    'bancontact': 'Bancontact',
    'paypal': 'PayPal',
    'applepay': 'Apple Pay',
    'googlepay': 'Google Pay',
    'klarna': 'Klarna',
    'sofort': 'SOFORT',
    'eps': 'EPS',
    'giropay': 'Giropay',
    'przelewy24': 'Przelewy24',
    'kbc': 'KBC',
    'belfius': 'Belfius',
    'banktransfer': 'Banktransfer',
    'directdebit': 'Direct debit',
    'giftcard': 'Giftcard',
    'voucher': 'Voucher',
    'in3': 'in3',
    'billie': 'Billie',
    'twint': 'TWINT',
    'blik': 'Blik',
    'bancomatpay': 'Bancomat',
    'trustly': 'Trustly',
    'riverty': 'Riverty',
    'satispay': 'Satispay',
};

function getPaymentMethodIcon(methodId) {
    const iconName = PAYMENT_METHOD_ICONS[methodId];
    if (iconName) {
        return `/static/img/payment_method_icons/Name=${iconName}, Size=2-Extra-large, Shape=Card.png`;
    }
    // Fallback to default icon
    return `/static/img/payment_method_icons/Name=Default, Size=2-Extra-large, Shape=Card.png`;
}

export default function PayForPlan() {

    const {planId} = useParams()
    const [form] = Form.useForm()
    const [plans, setPlans] = useState([])
    const [discountCode, setDiscountCode] = useState(null)
    const [paymentMethods, setPaymentMethods] = useState([])
    const {translate} = useTranslations()

    let selectedPlan = null

    useEffect(() => {
        api.getMyCompany().then(company => api.getAllPlans(company.billing_currency || company.country)).then(setPlans)
        api.getPaymentMethods().then(setPaymentMethods)
    }, []);


    if (plans.length > 0) {
        selectedPlan = plans.find(p => p.id === parseInt(planId))
    }

    function makePayment() {
        api.upgradePlan(planId, discountCode ? discountCode.code : null).then(({url}) => {
            try {
                trackFunnelEvent('begin_checkout', {
                    event_id: createFunnelEventId('begin_checkout'),
                    plan_id: planId,
                    currency: selectedPlan.currency,
                    value: discountCode ? selectedPlan.price - discountCode.discount : selectedPlan.price,
                })
            } catch {
                // Checkout success does not depend on analytics.
            }
            document.location = url
        })
    }

    function loadDiscountCode() {
        api.getDiscountCode(form.getFieldValue('discount_code')).then(setDiscountCode)
    }

    if (!selectedPlan) {
        return <Spin/>
    }

    return (
        <Row justify={"space-around"}>
            <Col md={8}>
                <h1 className={"text-center"}>{translate('Je gekozen pakket')}</h1>
                <PlanBox plan={selectedPlan} isActive={true}></PlanBox>
            </Col>
            <Col md={8}>
                <Form form={form} layout={"vertical"} onFinish={makePayment}>
                    <h1>{translate('Besteloverzicht')}</h1>

                    <table style={{width: '100%'}} className={"order-overview"}>
                        <thead>
                        <tr>
                            <th className={"text-left"}>{translate('Aantal')}</th>
                            <th className={"text-left"}>{translate('Product')}</th>
                            <th className={"text-right"}>{translate('Prijs')}</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr>
                            <td>1x</td>
                            <td>{selectedPlan.name}</td>
                            <td className={"text-right"}>{formatPlanPrice(selectedPlan.price, selectedPlan.currency)}</td>
                        </tr>
                        {discountCode && (
                            <tr>
                                <td>1x</td>
                                <td>{translate('Korting')} "{discountCode.code}"</td>
                                <td className={"text-right"}>-{formatPlanPrice(discountCode.discount, selectedPlan.currency)}</td>
                            </tr>
                        )}
                        <tr>
                            <td></td>
                            <td><strong>{translate('Te betalen')}</strong></td>
                            <td className={"text-right"}>
                                <strong>
                                    {formatPlanPrice(discountCode ? selectedPlan.price - discountCode.discount : selectedPlan.price, selectedPlan.currency)}
                                </strong>
                            </td>
                        </tr>
                        </tbody>
                    </table>

                    {selectedPlan.currency === 'USD' && (
                        <PurchaseDisclosure
                            plan={selectedPlan}
                            amountDueNow={discountCode ? selectedPlan.price - discountCode.discount : selectedPlan.price}
                        />
                    )}

                    <Form.Item label={"Kortingscode"} name={"discount_code"}>
                        <Input placeholder={"Kortingscode"} suffix={(
                            <Button onClick={loadDiscountCode}>{translate('Toevoegen')}</Button>
                        )}/>


                    </Form.Item>


                    <Form.Item className={"text-right"}>
                        <Button htmlType={"submit"} size={"large"} type={"primary"}>{translate('Naar betalen')}</Button>
                    </Form.Item>

                    <p>
                        {translate('Je kunt de betaalmethode kiezen als je op "Naar betalen" klikt.')}
                    </p>
                    <div style={{display: 'flex', flexWrap: 'wrap', gap: '8px', marginTop: '16px'}}>
                        {paymentMethods.map(method => (
                            <img
                                key={method.id}
                                src={getPaymentMethodIcon(method.id)}
                                alt={method.description}
                                title={method.description}
                                style={{height: '32px', width: 'auto'}}
                            />
                        ))}
                    </div>

                </Form>
            </Col>
        </Row>
    )
}
